document.addEventListener('DOMContentLoaded', function () {
  const data_notify_btn = document.querySelectorAll('[data-notify-btn]');
  const quick_buy_bis_trigger = document.querySelectorAll('[data-quick-buy-bis-trigger]');
  const bis_forms = document.querySelectorAll('[data-bis-form]');

  // Attach event listener for the notification buttons
  data_notify_btn.forEach(function (item) {
    item.addEventListener('click', function () {
      bis_forms.forEach(function (bis_form) {
        const bis_variant_id = bis_form.querySelector('[data-bis-variant-id]');
        bis_variant_id.value = item.getAttribute('data-variant-id');
      });
    });
  });

  // Handle quick buy trigger clicks
  quick_buy_bis_trigger.forEach(function (item) {
    item.addEventListener('click', function () {
      console.log('quick buy bis trigger clicked');
      const closest_form = item.closest('form');
      const quick_buy_variant_id = closest_form.querySelector('.product-variant-id').value;
      bis_forms.forEach(function (bis_form) {
        const bis_variant_id = bis_form.querySelector('[data-bis-variant-id]');
        bis_variant_id.value = quick_buy_variant_id;
      });
    });
  });

  // Reset all forms when modal is closed
  document.addEventListener('modal-window-closed', () => {
    bis_forms.forEach(function (bis_form) {
      bis_form.style.display = 'flex';
      const bis_success = bis_form.querySelector('[data-bis-success]');
      if (bis_success) {
        bis_success.style.display = 'none';
      }
      // Reset the form but don't remove event listeners
      bis_form.reset(); // Reset form fields
    });
  });

  // Handle form submissions
  function handleFormSubmit(event) {
    event.preventDefault();

    const form = event.target; // Access the form that triggered the event
    const fields = form.elements;
    const variantId = fields['bis_variant_id'].value;
    const emailAddress = fields['bis_email'].value;
    const klaviyoAPI = fields['bis_klaviyo_public_api_key'].value;

    let dataJson = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    const fetchOptions = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: '2024-07-15',
      },
      body: JSON.stringify(dataJson),
    };
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoAPI}`;

    fetch(url, fetchOptions)
      .then((response) => {
        if (response.ok) {
          form.style.display = 'none';
          const bis_success = document.querySelector('.modal-visuallyshow [data-bis-success]');
          bis_success.style.display = 'block';
        } else {
          response.json().then((data) => {
            console.log(data);
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // Add submit listener to each form if not added already
  bis_forms.forEach(function (bis_form) {
    // Make sure each form has a listener only once
    if (!bis_form.hasAttribute('data-listener-attached')) {
      bis_form.addEventListener('submit', handleFormSubmit);
      bis_form.setAttribute('data-listener-attached', 'true'); // Add flag to indicate listener is attached
    }
  });
});
